import { createDDSClient } from "@aelive/dds-client";

export const dds = createDDSClient({
  http: { url: `${process.env.REACT_APP_DDS_URL}/graphql` },
  ws: { url: `${process.env.REACT_APP_DDS_WS_URL}/graphql` }
});